<template>
  <div
    class="hero-picture-form flex flex-col items-center justify-center pb-8 px-4"
  >
    <div class="text-block text-center">
      <TypeDisplay variant="peta" weight="strong" tag="h1" class="mb-4">
        {{ title }}
      </TypeDisplay>
      <TypeHeading variant="headline" weight="regular" tag="h2">
        {{ subtitle }}
      </TypeHeading>
    </div>
    <div class="flex flex-col lg:flex-row items-center justify-center">
      <div class="w-1/2 mb-8 p-0 md:p-10">
        <img :src="heroImage" alt="hero-image" class="md:mb-0" />
      </div>
      <div class="flex-shrink-1 md:flex-shrink-0">
        <RegistrationPrompt button-id="company-size-button" class="shadow-lg" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { TypeDisplay, TypeHeading } from '@bambeehr/pollen';
import RegistrationPrompt from '@/components/RegistrationPrompt.vue';

export default defineComponent({
  name: 'HeroPictureForm',
  components: { RegistrationPrompt, TypeDisplay, TypeHeading },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    heroImage: {
      type: String,
      default: '',
    },
  },
  setup() {},
});
</script>

<style scoped>
.hero-picture-form {
  padding-top: 10rem;
}
</style>
